import React, { useEffect, useState, useRef, useCallback, createRef } from 'react';
import { connect } from "react-redux";
import * as actions from "../../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCircleChevronUp,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleChevronDown
} from "@fortawesome/free-solid-svg-icons";
import '../stylesheet/SnakeGame.css';

const SnakeGame = (props) => {
    const [dim, setDim] = useState(0);
    const [chunk, setChunk] = useState(0);
    const [direction, setDirection] = useState('right');
    const [fruit, setFruit] = useState(26);
    const [fruitPoint, setFruitPoint] = useState(1);
    const [fruitView, setFruitView] = useState(<p>&#129373;</p>);
    const [points, setPoints] = useState(0);
    const [game, setGame] = useState(false);
    const [highscore, setHighscore] = useState(<div className="game-highscore">&#127942; Mohamed Sajfan (100)</div>);
    const speedRef = useRef(100);
    const inputField = createRef();
    let width;
    const [snake, setSnake] = useState([
        {
            direction: 'right',
            part: [186, 185, 184, 183]
        }
    ]);

    const renderHighScore = () => {
        const { data } = props;
        const scores = _.orderBy(data, ['score', 'createAt'], ['desc', 'asc']);
        if (scores.length !== 0 && scores[0].score > points) {
            setHighscore(<div className="game-highscore">&#127942; {scores[0].name} ({scores[0].score})</div>);
        } else {
            setHighscore(<div className="game-highscore">&#127942; {points}</div>);
        }
    }

    const chooseFruit = (props) => {
        switch (props) {
            case 1:
                return <p>&#129373;</p>;
            case 2:
                return <p>&#129381;</p>;
            case 3:
                return <p>&#127815;</p>;
            case 4:
                return <p>&#127827;</p>;
            case 5:
                return <p>&#127826;</p>;
            case 6:
                return <p>&#129389;</p>;
            case 7:
                return <p>&#127825;</p>;
            case 8:
                return <p>&#127819;</p>;
            case 9:
                return <p>&#127818;</p>;
            case 10:
                return <p>&#127817;</p>;
            default:
                return <p>&#127815;</p>;
        }
    }

    const submitScore = () => {
        const { addSnakeGameScore } = props;
        let name = inputField.current.value;
        let score = points;

        if (name && score) {
            const createdAt = new Date().toString(); 
            addSnakeGameScore({
                name: name,
                score: score,
                createdAt: createdAt,
            });
            inputField.current.value = "";
            setPoints(0);
        }
    };

    const reset = () => {
        speedRef.current = 100;
        setPoints(0)
        setFruitPoint(1);
        setDirection('right')
        setSnake([{
            direction: 'right',
            part: [186, 185, 184, 183]
        }])
        setGame(false)
    }

    const pieces = () => {//functionally label snake pieces (bang) and return
        let arr = [];
        for (let i = 0; i < 400; i++) {
            let addToArr = false;
            let j = 0;
            while (j < snake.length) {
                if (snake[j].part.indexOf(i) >= 0) {
                    addToArr = true
                    break;
                } else {
                    addToArr = false
                }
                j++
            }
            addToArr ?
                arr.push('bang') :
                i === fruit ? arr.push('fruit') :
                    arr.push('')
        }
        return arr
    }

    //handle direction changes
    const turn = useCallback(
        (dir, opp) => {
            let tempSnake = [...snake];
            if (snake[0].part.length > 0 && direction !== opp && direction !== dir) {
                setDirection(dir)
                tempSnake.unshift({
                    direction: dir,
                    part: []
                })
                setSnake(tempSnake)
            }
        }, [snake, direction]
    )

    useEffect(() => {
        //determine relative dimensions of game portal
        props.fetchSnakeGamesScores();
        width = window.innerWidth;
        if (width >= 800) {
            setDim(width * .4)
        } else if (width < 800) {
            setDim(width * .8);
        }
        setChunk(dim / 20)

        renderHighScore();
        //points and get longer after eating
        if (snake[0].part[0] === fruit) {
            setPoints(points + fruitPoint)
            let sneak = [...snake];
            let firstSection = sneak[0]
            if (firstSection.direction === 'up') {
                let y = firstSection.part[0] - 20;
                if (y < 0) {
                    firstSection.part.unshift(y + 400);
                } else {
                    firstSection.part.unshift(y)
                }
            } else if (firstSection.direction === 'right') {
                let y = firstSection.part[0] + 1;
                if (y % 20 === 0) {
                    firstSection.part.unshift(y + - 20);
                } else {
                    firstSection.part.unshift(y)
                }
            } else if (firstSection.direction === 'down') {
                let y = firstSection.part[0] + 20;
                if (y >= 400) {
                    firstSection.part.unshift(y - 400);
                } else {
                    firstSection.part.unshift(y)
                }
            } else if (firstSection.direction === 'left') {
                let y = firstSection.part[0] - 1;
                if (y % 20 === 19) {
                    firstSection.part.unshift(y + 20);
                } else {
                    firstSection.part.unshift(y)
                }
            }
            speedRef.current = speedRef.current - 2
            setSnake(sneak)
            setFruit(Math.floor(Math.random() * Math.floor(400)))
            setFruitPoint(Math.floor((Math.random() * 10) + 1))
            let fruitNumber = fruitPoint;
            setFruitView(chooseFruit(fruitNumber))
        }

        //gameover if you eat your tail
        let totalArr = [];
        for (let k = 0; k < snake.length; k++) {
            totalArr = [...totalArr, ...snake[k].part]
        }
        let head = snake[0].part[0];
        totalArr.filter(item => item === head).length >= 2 && setGame(true)

        if (!game) {//if GAMEOVER pause events

            //listen for directions and update snake instructions accordingly
            const handleKeydown = (e) => {
                //let tempSnake: any = [...snake];
                switch (e.code) {
                    case 'ArrowUp':
                        e.preventDefault();
                        turn('up', 'down')
                        break;
                    case 'ArrowRight':
                        e.preventDefault();
                        turn('right', 'left')
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        turn('down', 'up')
                        break;
                    case 'ArrowLeft':
                        e.preventDefault();
                        turn('left', 'right')
                        break;
                    default:
                }
            }
            document.addEventListener('keydown', handleKeydown)

            //event interval
            const interval = setInterval(() => {

                //handle snake piece movement
                let dupSneak = [...snake];

                for (let i = (snake.length - 1); i > 0; i--) {//increment through current snake and reduce to head direction
                    if (dupSneak[i].part.length !== 0) {
                        let next = dupSneak[i - 1];
                        let chunk = dupSneak[i].part.shift();
                        next.part.push(chunk)
                    } else {
                        dupSneak.pop()
                    }
                }

                //perform movement changes to each chunk
                let sneak = dupSneak;
                sneak.map((section) => {
                    if (section.direction === 'right') {
                        section.part.map((x, i) => {
                            let y = x + 1;
                            if (y % 20 === 0) {
                                return section.part[i] = y - 20;
                            } else {
                                return section.part[i] = y
                            }
                        })
                    } else if (section.direction === 'up') {
                        section.part.map((x, i) => {
                            let y = x - 20;
                            if (y < 0) {
                                return section.part[i] = y + 400;
                            } else {
                                return section.part[i] = y
                            }
                        })
                    } else if (section.direction === 'left') {
                        section.part.map((x, i) => {
                            let y = x - 1;
                            if (y % 20 === 19) {
                                return section.part[i] = y + 20;
                            } else {
                                return section.part[i] = y
                            }
                        })
                    } else if (section.direction === 'down') {
                        section.part.map((x, i) => {
                            let y = x + 20;
                            if (y >= 400) {
                                return section.part[i] = y - 400;
                            } else {
                                return section.part[i] = y
                            }
                        })
                    }
                    return ''
                })
                setSnake(sneak)

            }, speedRef.current);

            //remove interval and listeners
            return () => {
                clearInterval(interval)
                document.removeEventListener('keydown', handleKeydown)
            };
        }
    }, [turn, width, dim, chunk, snake, direction, points, fruit, fruitPoint, fruitView, game])

    return (
        <div className="snake-container" id="snake-container">
            <div className="game-head">&#128013; Snake Game</div>
            <div
                className="point-bar"
                style={{ width: dim }}
            >
                <div className="game-score">&#127818; {points}</div>
                {highscore}
            </div>
            <div
                className="game-border"
                style={{ width: dim, height: dim }}
            >
                {
                    pieces().map((piece, i) => {
                        return <div
                            key={'piece' + i}
                            style={piece === 'bang' ?
                                { width: chunk, height: chunk, backgroundColor: props.color, borderRadius: '5px', border: '1px solid black' } :
                                { width: chunk, height: chunk }}
                        > {piece === 'fruit' ? fruitView : ''}
                        </div>
                    })
                }
                {
                    game && <div
                        className="game-splash"
                        style={{ height: dim }}
                    >
                        <div>Game Over!</div>
                        {points !== 0 ?
                            <div className="game-data-save">
                                <input type="text" placeholder="Enter name here" ref={inputField} name="name" required className="game-over-name" />
                                <button className="game-over-save" onClick={() => submitScore()}>Submit</button>
                            </div> : null}
                        <button
                            className="game-over-playagain"
                            onClick={() => reset()}
                        >
                            Play Again
                        </button>
                    </div>
                }
            </div>
            {
                window.innerWidth <= 800 ?
                    <div
                        className="snake-mobile-buttons"
                        style={{ width: dim }}
                    >
                        <div>
                            <button
                                onClick={() => turn('up', 'down')}
                            ><FontAwesomeIcon icon={faCircleChevronUp} size="2x" /></button>
                        </div>
                        <div>
                            <button
                                onClick={() => turn('left', 'right')}
                            ><FontAwesomeIcon icon={faCircleChevronLeft} size="2x" /></button>
                            <button
                                onClick={() => turn('right', 'left')}
                            ><FontAwesomeIcon icon={faCircleChevronRight} size="2x" /></button>
                        </div>
                        <div>
                            <button
                                onClick={() => turn('down', 'up')}
                            ><FontAwesomeIcon icon={faCircleChevronDown} size="2x" /></button>
                        </div>
                    </div> : ''
            }
        </div>
    )
}

const mapStateToProps = ({ data }) => {
    return {
        data,
    };
};

export default connect(mapStateToProps, actions)(SnakeGame);